import { DataProps } from '@models/transfer/common';
import { atom } from 'recoil';

export const tbdSendingState = atom<DataProps[] | []>({
  key: 'tbdSendingState',
  default: [],
});

export const tbdAllState = atom<DataProps[] | []>({
  key: 'tbdAllState',
  default: [],
});

export const allDataState = atom<DataProps[] | []>({
  key: 'allDataState',
  default: [],
});

export const sendingDataState = atom<DataProps[] | []>({
  key: 'sendingDataState',
  default: [],
});
